var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { display: "flex", "align-items": "center" } },
    [
      _vm.isDialog
        ? _c(
            "div",
            [
              _c(
                "el-button",
                {
                  attrs: { type: "text" },
                  on: {
                    click: function ($event) {
                      _vm.dialogVisible = true
                    },
                  },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("system::tip::upload_attachment")) + " "
                  ),
                  _c(
                    "span",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.currentVal.length,
                          expression: "currentVal.length",
                        },
                      ],
                    },
                    [
                      _vm._v(
                        "（已上传" + _vm._s(_vm.currentVal.length) + "个）"
                      ),
                    ]
                  ),
                ]
              ),
              _c(
                "el-dialog",
                _vm._b(
                  {
                    attrs: { title: "", visible: _vm.dialogVisible },
                    on: {
                      "update:visible": function ($event) {
                        _vm.dialogVisible = $event
                      },
                    },
                  },
                  "el-dialog",
                  _vm.$attrs,
                  false
                ),
                [
                  _c(
                    "div",
                    { staticClass: "dialog-wrap" },
                    [
                      _c(
                        "el-upload",
                        _vm._g(
                          _vm._b(
                            {
                              ref: "upload",
                              attrs: {
                                action: "",
                                "custom-class": "dialog-wrap",
                                drag: "",
                                "file-list": _vm.currentVal,
                                limit: _vm.limit,
                                "before-upload": _vm.customUpload,
                                "on-remove": _vm.removeFile,
                                "on-exceed": _vm.exceed,
                                "show-file-list": false,
                              },
                            },
                            "el-upload",
                            Object.assign({}, _vm.$attrs),
                            false
                          ),
                          Object.assign({}, _vm.$listeners)
                        ),
                        [
                          _vm.currentVal && _vm.currentVal.length
                            ? _c(
                                "div",
                                { staticClass: "upload_wrap" },
                                _vm._l(_vm.currentVal, function (item) {
                                  return _c(
                                    "div",
                                    { key: item.url, staticClass: "list-wrap" },
                                    [
                                      _c("p", [_vm._v(_vm._s(item.name))]),
                                      _c("i", {
                                        staticClass: "el-icon-close",
                                        on: {
                                          click: function ($event) {
                                            $event.stopPropagation()
                                            return _vm.removeItem(item)
                                          },
                                        },
                                      }),
                                    ]
                                  )
                                }),
                                0
                              )
                            : _c(
                                "div",
                                { staticClass: "upload_wrap" },
                                [
                                  _c("i", { staticClass: "el-icon-plus" }),
                                  _c(
                                    "el-button",
                                    { staticClass: "add-file-btn" },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$t("system::tip::upload_click")
                                        )
                                      ),
                                    ]
                                  ),
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$t("system::tip::upload_drag_tip")
                                      )
                                    ),
                                  ]),
                                ],
                                1
                              ),
                          _c(
                            "div",
                            {
                              staticClass: "el-upload__tip",
                              attrs: { slot: "tip" },
                              slot: "tip",
                            },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t(
                                      "system::tip::upload_limit_tip_new",
                                      { limit: _vm.limit, accept: _vm.accept }
                                    )
                                  ) +
                                  " "
                              ),
                            ]
                          ),
                        ]
                      ),
                    ],
                    1
                  ),
                ]
              ),
            ],
            1
          )
        : _c(
            "el-upload",
            _vm._g(
              _vm._b(
                {
                  ref: "upload",
                  attrs: {
                    action: "",
                    drag: "",
                    "file-list": _vm.currentVal,
                    limit: _vm.limit,
                    "before-upload": _vm.customUpload,
                    "on-remove": _vm.removeFile,
                    "on-exceed": _vm.exceed,
                    "show-file-list": false,
                  },
                },
                "el-upload",
                Object.assign({}, _vm.$attrs),
                false
              ),
              Object.assign({}, _vm.$listeners)
            ),
            [
              _vm.currentVal && _vm.currentVal.length
                ? _c(
                    "div",
                    { staticClass: "upload_wrap" },
                    _vm._l(_vm.currentVal, function (item) {
                      return _c(
                        "div",
                        { key: item.url, staticClass: "list-wrap" },
                        [
                          _c("p", [_vm._v(_vm._s(item.name))]),
                          _c("i", {
                            staticClass: "el-icon-close",
                            on: {
                              click: function ($event) {
                                $event.stopPropagation()
                                return _vm.removeItem(item)
                              },
                            },
                          }),
                        ]
                      )
                    }),
                    0
                  )
                : _c(
                    "div",
                    { staticClass: "upload_wrap" },
                    [
                      _c("i", { staticClass: "el-icon-plus" }),
                      _c("el-button", { staticClass: "add-file-btn" }, [
                        _vm._v(_vm._s(_vm.$t("system::tip::upload_click"))),
                      ]),
                      _c("span", [
                        _vm._v(_vm._s(_vm.$t("system::tip::upload_drag_tip"))),
                      ]),
                    ],
                    1
                  ),
              _c(
                "div",
                {
                  staticClass: "el-upload__tip",
                  attrs: { slot: "tip" },
                  slot: "tip",
                },
                [
                  _vm._v(
                    " " +
                      _vm._s(
                        _vm.$t("system::tip::upload_limit_tip_new", {
                          limit: _vm.limit,
                          accept: _vm.accept,
                        })
                      ) +
                      " "
                  ),
                ]
              ),
            ]
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }